module.exports = __webpack_public_path__ + "static/media/tirlan.d80af9c6.png";